module.exports = __webpack_public_path__ + "img/zhdp_summary_Image.6f49ef77.png";